import PropTypes from 'prop-types';
import moment from 'moment';
import { getOnSaleDate } from '../../helpers/event-search';

const OnSaleDateRenderer = ({ value, data }) => {
  return getOnSaleDate(data.event_links, value, moment(value).format('MM/DD/YYYY hh:mm A ddd'), data.event_id);
};

OnSaleDateRenderer.propTypes = {
  value: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default OnSaleDateRenderer;
